import {
  Component,
  computed,
  effect,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { RouterModule } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { UserService } from '@app/services/user.service';
import { UserProfileDto } from '@app/api/models';
import { NavigationRoutesService } from '@app/core/services/navigation-routes.service';
import { AuthService } from 'app/auth/auth.service';

@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    MatToolbarModule,
    TranslocoModule,
    RouterModule,
    MatIcon,
    MatChipsModule,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  private readonly userService = inject(UserService);
  private readonly navigationRoutes = inject(NavigationRoutesService);
  private readonly authService = inject(AuthService);

  @Input() isMobile!: boolean;
  @Input() isAuthenticated!: boolean;
  @Output() toggleMenu = new EventEmitter<void>();

  readonly mainUserData = computed<UserProfileDto | null>(() => {
    return this.userService.mainUserData();
  });
  readonly hideHeader = computed(() =>
    this.navigationRoutes.getHideHeader()
  );
  readonly isAdmin = computed(() =>
    this.authService.getDecodedToken().role === 'ADMIN'
  );
  headerData: UserProfileDto | null = null;

  constructor() {
    this.checkUserData();
    this.reloadUserData();
  }

  checkUserData() {
    if (!this.mainUserData()) {
      // Try main user data first, fall back to regular user data for backwards compatibility
      const mainData = sessionStorage.getItem('qualitime-main-ud');
      this.headerData = mainData
        ? JSON.parse(mainData)
        : JSON.parse(sessionStorage.getItem('qualitime-ud')!);
    } else {
      this.headerData = this.mainUserData();
    }
  }

  reloadUserData() {
    effect(() => {
      this.mainUserData();
      this.checkUserData();
    });
  }

  onToggleMenu() {
    this.toggleMenu.emit();
  }

  navigateTo(route: string) {
    window.location.href = route;
  }
}
